import React, { Component } from "react";
import Steps from "../../../../components/common/steps/Steps";
import { reduxForm } from "redux-form";
import Button from "../../../../components/common/button/Button";
import { Form, FormGroup, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { getUserData } from "../../../../actions/user.actions";
import _ from "lodash";

import Accordion from "./Accordion";
import styles from "./ProfessionalSkills.scss";

const steps = [
  {
    caption: "Your Profile",
    url: "complete-profile"
  },
  {
    caption: "Professional Skills",
    url: "skills"
  },
  {
    caption: "Endorsements",
    url: "endorsements"
  }
];

class ProfessionalSkills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStep: 1,
      totalSkills: 0
    };

    this.checkTotalSkills = this.checkTotalSkills.bind(this);
  }

  checkTotalSkills(add) {
    this.setState(prevState => {
      return { totalSkills: prevState.totalSkills + (add ? 1 : -1) };
    });
  }

  componentDidMount() {
    this.props.getUserData(() => {
      var firstSkill = document.getElementById("panel-title-1");
      firstSkill.focus();
      firstSkill.scrollIntoView();
    });
  }

  initialCountSkills(skills) {
    let count = 0;
    if (this.props.dirty == false) {
      Object.keys(skills).forEach(k => {
        count = count + skills[k].length;
      });
      this.setState(prevState => {
        if (prevState.totalSkills != count) {
          return { totalSkills: count };
        }
      });
    }
  }

  render() {
    const { submitting, valid, initialValues } = this.props;

    let selectedArray = new Array(7).fill(0);
    if (_.get(initialValues, "skills_all")) {
      this.initialCountSkills(initialValues.skills_all);
      Object.entries(initialValues.skills_all).forEach(skills => {
        selectedArray[parseInt(skills[0] - 1)] = skills[1].length;
      });
    }

    return (
      <section className={styles.professionalSkills}>
        <div className={styles.header}>
          <Steps steps={steps} activeStep={this.state.showStep} />
        </div>
        <div className={styles.content}>
          <h2 className={styles.title}>Make the Best Match</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <div className={styles.sectionDescription}>
                  Get matched to the best projects by selecting the most
                  accurate set of Fields and Skills.
                </div>
              </FormGroup>

              <FormGroup>
                <div className={styles.skillsTitle}>
                  What you choose here affects what shows up in your Projects
                  feed.
                </div>
                <div className={styles.skillsSubtitle}>
                  So be thorough, but select only the skills you have experience
                  in.
                </div>
                <div className={styles.skillsSubtitle}>
                  You may select up to 10 skills.
                </div>
              </FormGroup>
              <FormGroup>
                <div className={styles.dividerDouble} />

                <FormGroup>
                  {this.props.skills &&
                    this.props.skills.map((el, index) => (
                      <Accordion
                        name={el.name}
                        key={el.id}
                        selectedNumber={selectedArray[index]}
                        expanded={true}
                        checkTotalSkills={this.checkTotalSkills}
                        className={styles.panel}
                        hideCheckbox={true}
                        {...el}
                      />
                    ))}
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div md={12} style={{ textAlign: "center" }}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="SAVE + CONTINUE >"
                    isDisabled={
                      !valid || submitting || this.state.totalSkills > 10
                    }
                  />
                  {this.state.totalSkills > 10 ? (
                    <Alert bsStyle="danger">
                      <strong>Please select a maximum of 10 skills.</strong>
                      <br />
                      Prioritize your strongest skills, or the ones you'd like
                      to matched for the most.
                    </Alert>
                  ) : (
                    ""
                  )}
                </div>
              </FormGroup>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

ProfessionalSkills = reduxForm({
  form: "professionalSkills",
  enableReinitialize: true
})(ProfessionalSkills);

ProfessionalSkills = connect(
  state => {
    return {
      userData: state.user.data,
      initialValues: state.user.data
    };
  },
  dispatch => {
    return {
      getUserData: callback => dispatch(getUserData(callback))
    };
  }
)(ProfessionalSkills);

export default ProfessionalSkills;



// WEBPACK FOOTER //
// ./src/routes/candidate/professionalSkills/components/ProfessionalSkills.js